import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, FETCH_POINT, FETCH_POINT_LOG, M_POST } from '@/utils/api';

@Module({ name: 'point' })
export default class Point extends VuexModule {
  @Action({ rawError: true })
  async FetchPointReport(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_POINT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch point report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch point report failed');
    }
  }

  @Action({ rawError: true })
  async FetchPointLog(user: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + FETCH_POINT_LOG,
        data: user,
        method: M_POST
      });

      assertOk(data, 'Fetch point log failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch point log failed');
    }
  }
}
